

$(document).ready(function() {	

		var id = '#mc_embed_signup';


		//Delay


	if (!readCookie('pcp-pop')) {
		setTimeout(function(){
		
			createCookie('pcp-pop', 'popped', 7);
	
			//transition effect	overlay	
			$('#mask').fadeIn(500);	
	
		
			//transition effect
			$(id).fadeIn(800); 
	
	
		},10000) // 2 seconds.
	}

	
	//if close button is clicked
	$('.window .mc_embed_close').click(function (e) {
		//Cancel the link behavior
		e.preventDefault();
		
		$('#mask').hide();
		$('.window').fadeOut(300); 
	});		
	
	//if mask is clicked
	$('#mask').click(function () {
		$(this).hide();
		$('.window').hide();
	});		
	
});

function createCookie(name,value,days) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime()+(days*24*60*60*1000));
		var expires = "; expires="+date.toGMTString();
	}
	else var expires = "";
	document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
	var nameEQ = name + "=";
	var ca = document.cookie.split(';');
	for(var i=0;i < ca.length;i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1,c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
	}
	return null;
}

function eraseCookie(name) {
	createCookie(name,"",-1);
}

//CART ENVELOPE POPUP

$(document).ready(function() {	
		var id = '#envelope_popup';

    //Delay


		setTimeout(function(){
			
			//transition effect	overlay	
			$('#mask').fadeIn(500);	
	
		
			//transition effect
			$(id).fadeIn(800); 
	
	
		},1500) // 2 seconds.

	
	//if close button is clicked
	$('.window .envelope_popup_close').click(function (e) {
		//Cancel the link behavior
		e.preventDefault();
		
		$('#mask').hide();
		$('.window').fadeOut(300); 
	});		
	
	//if mask is clicked
	$('#mask').click(function () {
		$(this).hide();
		$('.window').hide();
	});		
	
});

